import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedDemoGymListList, DemoGymList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUseGyms {
  search?: string;
  type?: DemoGymList['type'];
  createdBy?: string;
}

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey?: (string | undefined)[];
}

export default function useDemoGyms({
  search,
  type,
  createdBy,
}: IUseGyms): UseInfiniteQueryResult<AxiosResponse<PaginatedDemoGymListList>> {
  const fetchGyms = useCallback(
    ({
      pageParam = { limit: '20', offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedDemoGymListList>> => {
      const params = pageParam;

      if (search) {
        params.search = search;
      }
      if (type) {
        params.type = type;
      }
      if (createdBy) {
        params.created_by = createdBy;
      }

      return client.get(`demo-gyms/?${encodeUrlParams(params)}`);
    },
    [createdBy, search, type],
  );

  return useInfiniteQuery(['demoGyms', search, type, createdBy], fetchGyms, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}
